import { Component } from '@angular/core';
import { ModalChildComponent } from '../modal/modal-child-component.interface';
import { ModalComponent } from '../modal/modal.component';

@Component({
    selector: 'finder-interstitial-modal',
    templateUrl: './interstitial-modal.component.html',
    styleUrls: ['./interstitial-modal.component.scss']
})
export class InterstitialModalComponent implements ModalChildComponent {

    parentComponent: ModalComponent;
    data: any;

    constructor() { }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
